import { IconButton } from "@mui/material";
import React, { memo, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import CloseIcon from "@mui/icons-material/Close";

type ImageViewProps = {
  style?: React.CSSProperties;
  src: string;
  alt: string;
  className?: string;
};

export const ImageView = memo(({ style, src, alt, className }: ImageViewProps) => {
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      <div onClick={() => setIsShow(true)}>
        <img src={src} alt={alt} className={className} style={style} />
      </div>
      {isShow && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-70 z-50 flex items-center justify-center ">
          <div>
            <div className="flex justify-end">
              <IconButton onClick={() => setIsShow(false)}>
                <CloseIcon sx={{ color: "#FFFFFF" }}></CloseIcon>
              </IconButton>
            </div>
            <TransformWrapper>
              <TransformComponent>
                <img src={src} alt={alt} />
              </TransformComponent>
            </TransformWrapper>
          </div>
        </div>
      )}
    </>
  );
});
